import styled from 'styled-components';

export const ResultsWrapper = styled.div`
  margin: 32px auto;
`;

export const ResultsHeading = styled.div`
  font-size: 16px;
  color: #444;
  font-weight: 800;
  margin-bottom: 8px;
`;

export const ResultsText = styled.div`
  font-size: 16px;
  color: #444;
  line-height: 24px;
  font-weight: 600;
`;
